import { downgradeComponent } from "@angular/upgrade/static";
import { RouteConfigHelperProvider } from "@services/routeConfigHelper.provider";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { DepotComplianceComponent } from "./depot-compliance/depot-compliance.component";
import { DriverBehaviourComparisonComponent } from "./driver-behaviour/driver-behaviour-comparison.component";
import { DriverBehaviourStackComponent } from "./driver-behaviour/driver-behaviour-stack/driver-behaviour-stack.component";
import { FindNearestComponent } from "./findNearest/findNearest.component";
import { FleetEventBarComponent } from "./fleetEvents/components/fleetEventBar/fleetEventBar.component";
import { FleetEventDetailsComponent } from "./fleetEvents/components/fleetEventDetails/fleetEventDetails.component";
import { FleetEventListItemComponent } from "./fleetEvents/components/fleetEventListItem/fleetEventListItem.component";
import { FleetEventsComponent } from "./fleetEvents/fleetEvents.component";
import { FleetHistoryJourneyScrubberComponent } from "./fleetHistory/components/fleetHistoryJourneyScrubber/fleetHistoryJourneyScrubber.component";
import { FleetHistoryTimeRangeSelectorComponent } from "./fleetHistory/components/fleetHistoryTimeRangeSelector/fleetHistoryTimeRangeSelector.component";
import { FleetHistoryComponent } from "./fleetHistory/fleetHistory.component";
import { h3Service } from "./h3.service";
import { ExploreNavigationModule } from "./insights.navigation";
import { IsochroneService } from "./isochrone.service";
import { VehicleUtilisationComponent } from "./vehicleUtilisation/vehicle-utilisation.component";

export class Config {

    static $inject = ["$stateProvider", "routeConfigHelperProvider"];

    constructor($stateProvider: StateProvider, routeConfigHelperProvider: RouteConfigHelperProvider) {

        routeConfigHelperProvider.$get().createState({
            stateName: ExploreNavigationModule.FleetHistory,
            url: "fleet-history",
            component: "fleetHistory",
            translation: 'FleetHistory.FleetHistory',
            subtitleTranslation: "FleetHistory.Intro"
        });

        routeConfigHelperProvider.$get().createState({
            stateName: ExploreNavigationModule.FleetUtilisation,
            url: "fleet-utilisation",
            component: "vehicleUtilisation",
            translation: 'FleetUtilisation.FleetUtilisation',
            subtitleTranslation: "FleetUtilisation.FleetUtilisationIntro"
        });

        routeConfigHelperProvider.$get().createState({
            stateName: ExploreNavigationModule.FleetEvents,
            url: "fleet-events",
            component: "fleetEvents",
            translation: 'FleetEvents.FleetEvents',
            subtitleTranslation: "FleetEvents.FleetEventsIntro"
        });

        routeConfigHelperProvider.$get().createState({
            stateName: ExploreNavigationModule.FindNearest,
            url: "find-nearest",
            component: "findNearest",
            translation: 'FindNearest.FindNearest',
            subtitleTranslation: "FindNearest.Intro"
        });

        routeConfigHelperProvider.$get().createState({
            stateName: ExploreNavigationModule.DriverBehaviour,
            url: "driver-behaviour-comparison",
            component: "driverBehaviourComparison",
            translation: 'DepotCompliance.DepotCompliance',
            subtitleTranslation: "DepotCompliance.Intro"
        });

        routeConfigHelperProvider.$get().createState({
            stateName: ExploreNavigationModule.DepotCompliance,
            url: "depot-compliance",
            component: "depotCompliance",
            translation: 'DepotCompliance.DepotCompliance',
            subtitleTranslation: "DepotCompliance.Intro"
        });

        routeConfigHelperProvider.createDetailStateWithBoundParams({
            stateName: `${ExploreNavigationModule.FleetEvents}.view`,
            bindingName: "vehicleId",
            component: "vehicleVideoCard",
            queryParamsNames: ["tab", "requestVideoTime"],
            breadcrumbNameResolverKey: "vehicleVideoNameKey"
        });

        $stateProvider.state(ExploreNavigationModule.ParentRoot, {
            abstract: true,
            url: "/explore/",
            redirectTo: ExploreNavigationModule.Default,
            views: { "module-navigation": {} },
            data: { translation: 'Common.Explore' }
        });
    }
}

angular
    .module("app.components.insights",
        [
            "ui.router",
            "ngAnimate"
        ])
    .config(Config)
    .component("findNearest", new FindNearestComponent())
    .directive("vehicleUtilisation", downgradeComponent({ component: VehicleUtilisationComponent }))
    .directive("depotCompliance", downgradeComponent({ component: DepotComplianceComponent }))

    .directive("driverBehaviourComparison", downgradeComponent({ component: DriverBehaviourComparisonComponent }))
    .directive("driverBehaviourStack", downgradeComponent({ component: DriverBehaviourStackComponent }))

    .component("fleetHistory", new FleetHistoryComponent())
    .component("fleetHistoryTimeRangeSelector", new FleetHistoryTimeRangeSelectorComponent())
    .component("fleetHistoryJourneyScrubber", new FleetHistoryJourneyScrubberComponent())

    .component("fleetEvents", new FleetEventsComponent())
    .component("fleetEventBar", new FleetEventBarComponent())
    .component("fleetEventDetails", new FleetEventDetailsComponent())
    .component("fleetEventListItem", new FleetEventListItemComponent())

    .service("isochroneService", IsochroneService)
    .service("h3Service", h3Service);

